import defaultLoginMethod from './loginMethods/defaultLoginMethod';
import nestLoginMethod from './loginMethods/nestLoginMethod';

const loginServices = [
    defaultLoginMethod,
    nestLoginMethod,
]

function resolveLoginService(loginMethod) {
    for (const method of loginServices) {
        if (method.supports(loginMethod)) {
            return method;
        }
    }

    return defaultLoginMethod;
}

export function getLoginService(loginMethod) {
    let loginService = resolveLoginService(loginMethod);
    return {
        ...loginService,
        isExternalMethod: () => !loginService.supports('DEALER_ID'),
    }
}